export default __webpack_public_path__ + "static/media/O-126.22c238e9.png";